// extracted by mini-css-extract-plugin
module.exports = {"container":"ShipmentDetail_container__2LmYz"};